import { render, staticRenderFns } from "./list.vue?vue&type=template&id=36e69abb&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=36e69abb&prod&lang=less&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=36e69abb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e69abb",
  null
  
)

export default component.exports